"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableName = void 0;
const make_letter_case_1 = require("../../../../../utilities/strings/make-letter-case");
function getTableName(selectedType) {
    return (0, make_letter_case_1.makeLetterCase)(selectedType) + ' Outbound Queue Items';
}
exports.getTableName = getTableName;
